export default async ({ $config, store, i18n }, inject) => {
  const { APP_ENV, SMARTICO_SCRIPT_URL, SMARTICO_KEY, SMARTICO_BRAND_KEY } = $config

  store.subscribe((mutation, state) => {
    if (mutation.type === 'user/SET_PROFILE_INFO') {
      const userId = state.user.user.id

      if (userId && !window?._smartico_user_id) {
        window._smartico_user_id = userId
        window._smartico_language = i18n.locale
        // TODO: made window._smartico_language switching locale when change locale
      }
    }
    else if (mutation.type === 'user/logout') {
      window._smartico_user_id = null
      window._smartico_language = null
    }
  })

  if (APP_ENV === 'localhost') {
    window._smartico_allow_localhost = true
  }

  try {
    await new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = SMARTICO_SCRIPT_URL
      script.async = true
      script.onload = resolve
      script.onerror = reject
      document.head.appendChild(script)
    })
  }
  catch (error) {
    console.error(error)
  }

  const smartico = window?._smartico || null

  if (smartico) {
    smartico.init(SMARTICO_KEY, { brand_key: SMARTICO_BRAND_KEY })
  }

  inject('smartico', smartico)
}
